import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { MedicationRequestFilter } from "@/app/components/legacy-components";
import { RedirectToSync } from "@/app/components/legacy-modals";
import { ROUTES } from "@/app/router";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { useConsultationStore } from "@/features/consultations/contexts";
import { LogoLoader } from "@/shared/components";
import { useBoolean } from "@/shared/hooks";
import { CONSULTATION_PURPOSE } from "@/shared/models/legacy-constants";
import { UpcomingConsultationModal } from "./components";

interface FilterForm {
  onContinue: () => void;
}

export const FilterForm = ({ onContinue }: FilterForm) => {
  const navigate = useNavigate();
  const {
    value: showRedirectModal,
    setTrue: openRedirectModal,
    setFalse: closeRedirectModal,
  } = useBoolean(false);
  const {
    value: showUpcomingConsultationModal,
    setTrue: openUpcomingConsultationModal,
    setFalse: closeUpcomingConsultationModal,
  } = useBoolean(false);

  const setPurpose = useConsultationStore((state) => state.setPurpose);

  const {
    data: upcomingMedicationRequestConsultations,
    isLoading: isLoadingUpcomingConsultations,
    isSuccess: isSuccessUpcomingConsultations,
  } = useQuery(
    consultationsQueriesStore.consultations.appointments._ctx.list._ctx.upcoming
      ._ctx.medicationRequest,
  );

  const handleFilterResult = (isDisqualified: boolean) => {
    if (!isDisqualified) {
      return onContinue();
    }

    if (upcomingMedicationRequestConsultations?.length) {
      return openUpcomingConsultationModal();
    }

    openRedirectModal();
  };

  return (
    <>
      <LogoLoader show={isLoadingUpcomingConsultations} withOverlay />

      {isSuccessUpcomingConsultations && (
        <>
          <MedicationRequestFilter
            onBack={() => navigate(ROUTES.CONSULTATIONS.PURPOSE)}
            onNext={handleFilterResult}
          />
          <RedirectToSync
            show={showRedirectModal}
            onClose={closeRedirectModal}
            onConfirm={() => {
              setPurpose(CONSULTATION_PURPOSE.CONSULTATION);
              navigate(ROUTES.CONSULTATIONS.FOLLOW_UP);
            }}
          />
        </>
      )}

      <UpcomingConsultationModal
        show={showUpcomingConsultationModal}
        onClose={closeUpcomingConsultationModal}
      />
    </>
  );
};
